import { render, staticRenderFns } from "./OrganizationMDTDDocument.vue?vue&type=template&id=51908ffe&scoped=true"
import script from "./OrganizationMDTDDocument.vue?vue&type=script&lang=js"
export * from "./OrganizationMDTDDocument.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMDTDDocument.vue?vue&type=style&index=0&id=51908ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51908ffe",
  null
  
)

export default component.exports